import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SENDOUT_NAMESPACE } from "src/i18n";
import "src/pages/sendout/Generic/components/FormSelect.css";

interface FormOption {
  id: string;
  name: string;
  description: string;
}

interface FormSelectProps {
  options: FormOption[];
  onChange?: (selectedId: string) => void;
}

export default function FormSelect({ options, onChange }: FormSelectProps) {
  const { t } = useTranslation(SENDOUT_NAMESPACE);
  const [selectedId, setSelectedId] = useState("");

  const handleChange = (id: string) => {
    setSelectedId(id);
    onChange?.(id);
  };

  return (
    <fieldset className="form-radio-fieldset">
      <legend className="form-radio-legend">
        {t("sendoutFormSelectLabel")}
      </legend>
      <div className="form-radio-group">
        {options.map((option) => (
          <label
            key={option.id}
            className={`form-radio-card ${selectedId === option.id ? "form-radio-card--selected" : ""}`}
            htmlFor={`form-radio-${option.id}`}
          >
            <input
              type="radio"
              id={`form-radio-${option.id}`}
              name="form-select"
              value={option.id}
              checked={selectedId === option.id}
              onChange={() => handleChange(option.id)}
              className="form-radio-input"
            />
            <div className="form-radio-content">
              <span className="form-radio-name">{option.name}</span>
              <span className="form-radio-description">{option.description}</span>
            </div>
          </label>
        ))}
      </div>
    </fieldset>
  );
}